import React, { FC } from 'react';
import { View } from 'react-native';

import { Body2Reg, Caption1Bold } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { entryBlocks } from '../../utils/activities/entryBlocks';

/**
 * One recorded diary entry, read back. The question is a label and the answer
 * is what the user wrote: they must not read as one block of text.
 */
export const ActivityEntryBody: FC<{ entry: string }> = ({ entry }) => (
  <View style={{ rowGap: SPACING['sp-12'] }}>
    {entryBlocks(entry).map((block, index) => (
      <View key={index} style={{ rowGap: SPACING['sp-4'] }}>
        {!!block.question && (
          <Caption1Bold color={COLORS.content.secondary}>{block.question}</Caption1Bold>
        )}
        <Body2Reg selectable={true}>{block.answer}</Body2Reg>
      </View>
    ))}
  </View>
);
